import { plugin, Mode } from 'light-component';
import { useTranslation } from '../../../i18n';
import { Thumbnail } from '../../component';
import { WidgetGroup, WidgetType } from '../types';
import { BlockDesignMode } from './design';
import { BlockViewMode } from './view';
import { BlockInputMode } from './input';
import type { ReactElement } from 'react';
import type { BlockProps } from './types';

// 问卷-分组
export function QuestionnaireBlock(props: BlockProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (
      <Thumbnail icon='BlockIcon' title={t('Block')} toolTipContent={t('给题目分类，可包含若干题目')} />
    );
  }

  if (props.mode === Mode.DESIGN) {
    return (<BlockDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<BlockViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<BlockInputMode {...props} />);
  }

  return null;
}

QuestionnaireBlock.prototype.type = WidgetType.BLOCK;
QuestionnaireBlock.prototype.group = WidgetGroup.BLOCK;
plugin.register({ kind: 'widget', component: QuestionnaireBlock });
